import { MapPin, Instagram, AtSign, Globe } from "lucide-react";
import Logo from "./Logo";
import WhatsAppIcon from "./WhatsAppIcon";
import { goTo, WHATSAPP_URL, INSTAGRAM_URL, THREADS_URL, GOOGLE_URL } from "@/lib/scroll";

const NAV = [
  ["Sintomas", "#sintomas"],
  ["Sobre", "#sobre"],
  ["Diferencial", "#diferencial"],
  ["Consulta", "#consulta"],
  ["Depoimentos", "#depoimentos"],
  ["Dúvidas", "#faq"],
];

const SOCIALS = [
  ["Instagram", INSTAGRAM_URL, Instagram, "footer-social-instagram"],
  ["Threads", THREADS_URL, AtSign, "footer-social-threads"],
  ["WhatsApp", WHATSAPP_URL, null, "footer-social-whatsapp"],
  ["Google", GOOGLE_URL, Globe, "footer-social-google"],
];

export default function Footer() {
  return (
    <footer className="bg-olive-deep text-cream" data-testid="footer">
      <div className="mx-auto max-w-[1240px] px-5 md:px-10 py-16 md:py-20">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <Logo variant="vertical" />
            <p className="mt-5 max-w-xs font-serifd italic text-cream/60">
              Neurologia integrativa — um olhar no seu quadro como um todo.
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-x-14 gap-y-3" data-testid="footer-nav">
            {NAV.map(([label, hash]) => (
              <a
                key={hash}
                href={hash}
                onClick={goTo(hash)}
                className="text-cream/75 transition hover:text-sun"
              >
                {label}
              </a>
            ))}
          </nav>

          <div className="max-w-sm">
            <p className="flex items-start gap-3 text-cream/75 leading-relaxed">
              <MapPin className="mt-1 size-5 shrink-0 text-sun" />
              Rua Dalcídio Jurandir, 255, sala 159 — Barra da Tijuca, Rio de Janeiro/RJ · CEP
              22631-250
            </p>
            <p className="mt-3 text-sm tracking-wide text-cream/55">
              CRM-RJ 0114708-0 · Atendimento particular
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map(([label, url, Icon, testid]) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={testid}
                  className="inline-flex size-11 items-center justify-center rounded-full border border-cream/25 text-cream/85 transition-all duration-300 hover:-translate-y-1 hover:border-sun hover:bg-sun hover:text-olive"
                >
                  {Icon ? <Icon className="size-5" /> : <WhatsAppIcon className="size-5" />}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-cream/15 pt-7 text-sm text-cream/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Mariane Prado — Neurologia. Todos os direitos reservados.</p>
          <p className="font-serifd italic">feito com escuta, investigação e clareza</p>
        </div>
      </div>
    </footer>
  );
}
